import Command from '@ckeditor/ckeditor5-core/src/command';

export default class MoveSlideDownCommand extends Command {
    execute() {
        const model = this.editor.model;
        const slide = model.document.selection.getSelectedElement().findAncestor('RhSwiperSlide');

        model.change( writer => {
            writer.insert( slide, slide.nextSibling, 'after')
        });
    }

    refresh() {
        const model = this.editor.model;
        const element = model.document.selection.getSelectedElement();

        if(null == element){
            this.isEnabled = false;
            return;
        }

        const slide = model.document.selection.getSelectedElement().findAncestor('RhSwiperSlide');

        this.isEnabled = (null != slide) && (null != slide.nextSibling);
    }
}
